import type { MutationHookOptions } from "@apollo/client";
import { useMutation, gql } from "@apollo/client";

const USER_SIGN_IN_MUTATION = gql`
  mutation UserSignIn_UnauthenticatedShared_Mutation($input: AuthUserSignInInput!) {
    auth {
      userSignIn(input: $input) {
        user {
          id
        }
        redirectPath
        errors {
          message
        }
      }
    }
  }
`;

interface AuthUserSignInInput {
  email: string;
  password: string;
  staySignedIn?: boolean;
  optional?: any;
}

interface Variables {
  input: {
    attributes: AuthUserSignInInput;
    captchaToken: string;
  };
}

interface UserSignInError {
  message: string;
}

interface User {
  id: string;
}

interface UserSignInMutationData {
  auth: {
    userSignIn: {
      user: User;
      redirectPath: string;
      errors: UserSignInError;
    };
  };
}

const useUserSignIn = (options?: MutationHookOptions<UserSignInMutationData, Variables>) =>
  useMutation<UserSignInMutationData, Variables>(USER_SIGN_IN_MUTATION, options);

export type { Variables, UserSignInMutationData };

export { USER_SIGN_IN_MUTATION, useUserSignIn };
